import { Box, TextField, Grid, useTheme } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { ButtonV1, DropdownV1 } from "components";
import { PRIORITY_VALUES } from "constants";
const CustomTextField = ({ name, label, control }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <TextField
          size="small"
          label={label}
          onChange={onChange}
          value={value}
          style={{ width: "100%" }}
        />
      )}
    />
  );
};

const Filters = ({ onFilterSubmit, onResetFilter }) => {
  const theme = useTheme();
  const {
    control,
    reset,
    handleSubmit,
    formState: { isDirty },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      orderNumber: "",
      orderPriority: "",
    },
  });

  const handleFilter = (data) => {
    onFilterSubmit(data); // Pass form values to the parent component
  };

  const handleReset = () => {
    reset(); // Reset the form to default values
    onFilterSubmit({});
    onResetFilter();
  };

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderRadius: 2,
        padding: 3,
      }}
    >
      <Box p={2} as="form" onSubmit={handleSubmit(handleFilter)}>
        <Grid container spacing={2} columns={10}>
          <Grid item xs={10} md={2}>
            <Controller
              control={control}
              name={"orderNumber"}
              render={({ field: { value, onChange } }) => (
                <TextField
                  size="small"
                  label={"Order Number"}
                  onChange={onChange}
                  value={value}
                  style={{ width: "100%" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={10} md={2}>
            <Controller
              control={control}
              name={"orderPriority"}
              render={({ field: { value, onChange } }) => (
                <DropdownV1
                  itemList={PRIORITY_VALUES}
                  value={value}
                  onChange={onChange}
                  listType="array"
                  placeholder={"Priority"}
                />
              )}
            />
          </Grid>
          <Grid item xs={10} md={2}>
            <ButtonV1
              title={"Submit"}
              type="submit"
              style={{ width: "100%" }}
              disabled={!isDirty}
            />
          </Grid>
          <Grid item xs={10} md={2}>
            <ButtonV1
              title={"Reset"}
              variant="outlined"
              disabled={!isDirty}
              style={{ width: "100%" }}
              onClick={handleReset}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Filters;

Filters.propTypes = {
  onFilterSubmit: PropTypes.func,
  onResetFilter: PropTypes.func,
};
